// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3F26G","alertIcon":"ConfirmModal_alertIcon__3OB4v"};